import React, { Component } from "react";
import Timer from "~/components/Timer/timer-svg"

class CountDownPlaceHolder extends Component {
  render() {
    const { startTime, endTime, closeTimer, displayDetailedTime } = this.props;
    return <div className="countdown-placeholder">
      <Timer {...{ scheduleStartDate: startTime, scheduleEndDate: endTime, closeTimer: closeTimer, displayDetailedTime: displayDetailedTime }} />
      </div>;
  }
}

export default CountDownPlaceHolder;